import React, { useContext, useEffect, useState } from "react";
import "./Man_Behind_The_Power.css";
import {
  faFacebookF,
  faInstagram,
  faXTwitter,
} from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ManBehindPowers } from "../../../utils/apis/aboutus/Aboutus.js";
import { Context } from "../../../utils/context";
import { IDS } from "../../../utils/common";
import Common_heading from "../../common/common_heading/Common_heading.js";

const Man_Behind_The_Power = () => {
  const HtmlToReactParser = require("html-to-react").Parser;
  const htmlToReactParser = new HtmlToReactParser();

  const [manbehindpower, setManBehindPower] = useState({});

  const getManBehindPower = async () => {
    const res = await ManBehindPowers();
    if (res?.success) {
      setManBehindPower(res?.data?.data?.[0] || {});
    }
  };

  useEffect(() => {
    getManBehindPower();
  }, []);

  return (
    <section className="power-section">
      <Common_heading
        title={"The Man Behind the Power"}
        subtitle={"Discover the story behind our visionary leader"}
      />
      <div className="container mt-4">
        <div className="power-container">
          <div className="row">
            <div className="col-md-4">
              {/* Left Column: Image Area */}
              <div className="power-image-wrapper">
                <img
                  src={IDS?.IMG_URL + manbehindpower?.image}
                  alt={manbehindpower?.name || "Founder"}
                  className="man-image"
                />
              </div>
            </div>

            <div className="col-md-8">
              {/* Right Column: Premium Text Layout */}
              <div className="power-content-wrapper">
                <div className="text_content">
                  <h2 className="main-title">
                    {manbehindpower?.position ||
                      "AI without the hype: transforming data into action"}
                  </h2>

                  <p className="name-heading">
                    By {manbehindpower?.name || "Jonathan Cherki"}
                  </p>

                  <div className="description-text">
                    {htmlToReactParser.parse(manbehindpower?.description)}
                  </div>

                  {manbehindpower?.shortdescription && (
                    <blockquote className="quote-text">
                      "{manbehindpower?.shortdescription}"
                    </blockquote>
                  )}

                  {/* Social Icons & Signature Placement */}
                  <div className="power-footer">
                    <div className="social-icons">
                      {[
                        { icon: faFacebookF, link: "https://www.facebook.com" },
                        {
                          icon: faInstagram,
                          link: "https://www.instagram.com",
                        },
                        { icon: faXTwitter, link: "https://www.twitter.com" },
                      ].map((item, index) => (
                        <a
                          key={index}
                          href={item.link}
                          className="social_link"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <FontAwesomeIcon
                            icon={item.icon}
                            className="social-icon"
                          />
                        </a>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Man_Behind_The_Power;
